import { useDisclosure } from '@mantine/hooks';

export interface IProps {
  isOpen: boolean;
  openModal: () => void;
  closeModal: () => void;
}

export function useCRMConnectModal(): IProps {
  const [isOpen, { open: openModal, close: closeModal }] = useDisclosure(false);

  return {
    isOpen,
    openModal,
    closeModal,
  };
}
